<template>
  <SectionPageShell
    section="ads"
    :title="ad?.title || 'Werbeanzeige bearbeiten'"
    :subtitle="ad?.title ? 'Werbeanzeige bearbeiten' : null"
    show-back-link
  >
    <AdForm v-if="ad" :initial-values="ad" @submitted="updateAd" />
  </SectionPageShell>
</template>

<script>
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import {useAdsStore} from "@/stores/ads";
import AdForm from "@/pages/ads/Form.vue";

export default {
  components: {
    AdForm,
    SectionPageShell,
  },
  setup() {
    return {
      adStore: useAdsStore(),
    }
  },
  data() {
    return {
      ad: null,
    }
  },
  created() {
    this.adStore.show(this.$route.params.ad_id).then(({data}) => {
      this.ad = data
      this.adStore.loading = false
    })
  },
  methods: {
    updateAd(values) {
      this.adStore.update(this.$route.params.ad_id, values)
    },
  },
}
</script>
